import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Spinner } from '@/components/ui/Spinner';
import { paths } from '@/routes/paths';
import { useCompany } from '@/api/queries/employer';
import { IcSearch } from '@/components/ui/icons';

export function BusinessEmptyPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const company = useCompany();

  if (company.isLoading) {
    return (
      <AppShell>
        <PageContainer>
          <TopBar title={t('nav.business')} bell />
          <Spinner />
        </PageContainer>
      </AppShell>
    );
  }

  if (company.data) {
    navigate(paths.businessCabinet, { replace: true });
  }

  return (
    <AppShell>
      <PageContainer>
        <TopBar title={t('nav.business')} bell onBellClick={() => navigate(paths.notifications)} />
        <Card variant="light" padding="md">
          <div style={{ fontWeight: 600 }}>{t('business.empty_title')}</div>
          <div style={{ color: 'var(--color-text-on-light-muted)', marginBlock: 6 }}>
            {t('business.empty_value')}
          </div>
          <p style={{ margin: 0 }}>{t('business.empty_body')}</p>
          <Button block style={{ marginTop: 16 }} variant="primary" onClick={() => navigate(paths.businessCreate)}>
            {t('business.create')}
          </Button>
        </Card>
        <Input
          startAdornment={<IcSearch />}
          placeholder={t('business.search_placeholder')}
          aria-label={t('business.search')}
          onClick={() => navigate(paths.businessSearch)}
          readOnly
        />
      </PageContainer>
    </AppShell>
  );
}
